import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject, finalize } from 'rxjs';
import { UpdateDataTokenCode } from 'src/app/shared/class/update-data';
import {
  City,
  DataSelects,
  VehicleFinancingId,
  WaysFindOut,
} from 'src/app/shared/interfaces/data-selects';
import {
  StepInitResponse,
  StepWelcomeLto,
} from 'src/app/shared/interfaces/step-data';
import { PrivacyTermsComponent } from 'src/app/shared/privacy-terms/privacy-terms.component';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { PostDataService } from 'src/app/shared/services/post-data.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';
import { FormsValidators } from 'src/app/shared/utils/forms-validators';

@Component({
  selector: 'app-step-bienvenida-lto',
  templateUrl: './step-bienvenida-lto.component.html',
  styleUrls: ['./step-bienvenida-lto.component.scss'],
})
export class StepBienvenidaLtoComponent extends AutoUnsubscribeComponent implements OnInit {
  @Input() saveRequest!: Observable<boolean>;
  @Input() dataWelcomeLto!: DataSelects;
  @Output() formValidEvent = new EventEmitter<boolean>();
  @Output() stepWelcomeLtoSavedEvent = new EventEmitter<boolean>();

  public formStepWelcomeLto!: FormGroup;
  public requestNumber = '';
  protected _onDestroy = new Subject<void>();
  public emailCtrl: FormControl = new FormControl('');
  public country: string | undefined;
  public waysFindOuts: WaysFindOut[] = [];
  public creditTypeUpdate!: string;
  public workingCities: City[] = [];
  public vehicleCategoriesCredit: VehicleFinancingId[] = [];
  public vehicleSelect!: string;
  public vehicleRequired = false;
  public viewButtonSelect = false;
  public emailPromoter: any = '';
  public city: string = '';
  public referall: string = '';
  private secondaryCreateResponse: any = null;
  private saveAfterAcceptPrivacy = true;
  public referralCode!: string;
  public vehicleType: string = '';
  public referallId: string = '';

  constructor(
    private frmBuilder: FormBuilder,
    private postDataService: PostDataService,
    private dialog: MatDialog,
    private requestFormService: RequestFormService,
    private putDataService: PutDataService,
    private activatedRouter: ActivatedRoute
  ) {
    super();

    this.activatedRouter.queryParams.subscribe((params) => {
      this.requestNumber = params['requestNumber'];
      this.city = params['city'];
      this.referall = params['referall'];
      this.referralCode = params['referralCode'];
      this.vehicleType = params['vehicleType'];
      this.referallId = params['referallId'];
    });
    this.emailPromoter =
      this.activatedRouter.snapshot.queryParams['emailPromoter'];
    if (this.emailPromoter) {
      this.emailPromoter = window.atob(this.emailPromoter);
    }
  }

  ngOnInit(): void {
    const EMAIL = /^[\w-.!#$%&'*+-/=?^_`{|}~]+@([\w-]+\.)+[\w-]{2,6}$/;
    const MOBILE = /^[0-9]{10}$/;

    this.formStepWelcomeLto = this.frmBuilder.group({
      firstName: [
        '',

        [
          Validators.required,
          Validators.maxLength(45),
          Validators.minLength(2),
        ],
      ],
      lastName: [
        '',

        [
          Validators.required,
          Validators.maxLength(45),
          Validators.minLength(2),
        ],
      ],
      secondLastName: [

        '',

        [Validators.maxLength(45), Validators.minLength(2)],
      ],
      mobilePhoneNumber: [
        '',

        [Validators.required, Validators.pattern(MOBILE)],
      ],
      privacyNoticeAccepted: [
        '',

        [Validators.requiredTrue],
      ],
      workCityId: [
        '',

        [Validators.required],
      ],
      whereFindOutId: [
        {
          value: '',
          disabled: this.requestFormService.getUpdateForm()
            ? !this.requestFormService.getUpdateForm()?.canEdit
            : (this.referralCode != null || this.referallId != null)
              ? true
              : false,
        },
        [Validators.required],
      ],
      anotherJobCity: [
        '',

      ],
      anotherWayFindOut: [
        '',

      ],
    });

    this.emailCtrl.setValidators([
      Validators.required,
      Validators.pattern(EMAIL),
      FormsValidators.validateEmailEnd(),
    ]);

    if (this.requestFormService.getDataForm().requestNumber) {
      this.loadUpdateFormStepWelcome();
      this.emailCtrl.disable();
      this.formStepWelcomeLto.controls['mobilePhoneNumber'].disable();
      this.viewButtonSelect = true;
    }

    this.saveRequest.subscribe((value) => {
      if (value) {
        if (this.formStepWelcomeLto.dirty) {
          this.saveStepWelcome();
        } else {
          this.stepWelcomeLtoSavedEvent.emit(true);
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataWelcomeLto']?.currentValue) {
      let visibleWaysFindOut: WaysFindOut[] = [];
      visibleWaysFindOut = this.dataWelcomeLto.waysFindOut.filter((ways) => ways.visible);
      this.waysFindOuts = this.dataWelcomeLto.waysFindOut
        .filter((ways) => {
          return ways.name != 'OTRA (Especifique)' && visibleWaysFindOut.includes(ways);
        })
        .sort((a, b) => a.name.localeCompare(b.name));
      const waysFindOutsOther = this.dataWelcomeLto.waysFindOut.find(
        (act) => act.name == 'OTRA (Especifique)'
      );
      if (waysFindOutsOther) {
        this.waysFindOuts.push(waysFindOutsOther);
      }

      const waysFindOut = this.waysFindOuts.find(
        (referall) => referall.name == this.referall
      );
      if (waysFindOut) {
        this.formStepWelcomeLto.controls['whereFindOutId'].setValue(
          waysFindOut.id
        );
        this.formStepWelcomeLto.controls['whereFindOutId'].disable();
      }

      const waysFindOutId = this.waysFindOuts.find(
        (referallId) => referallId.id == this.referallId
      );
      if (waysFindOutId) {
        this.formStepWelcomeLto.controls['whereFindOutId'].setValue(
          waysFindOutId.id
        );
        this.formStepWelcomeLto.controls['whereFindOutId'].disable();
      }

      this.workingCities = this.dataWelcomeLto.cities
        .filter((city) => city.code != 'Especifique')
        .sort((a, b) => a.name.localeCompare(b.name));

      const jobCityOther = this.dataWelcomeLto.cities.find(
        (c) => c.code === 'Especifique'
      );
      if (jobCityOther) {
        this.workingCities.push(jobCityOther);
      }

      const workingCity = this.workingCities.find(
        (city) => city.id == this.city
      );
      if (workingCity) {
        this.formStepWelcomeLto.controls['workCityId'].setValue(workingCity.id);
        this.formStepWelcomeLto.controls['workCityId'].disable();
      }

      this.vehicleCategoriesCredit = this.dataWelcomeLto.vehicleFinancingId;

      const vehicleCategory = this.vehicleCategoriesCredit.find(
        (vehic) => vehic.id == this.vehicleType
      );
      if (vehicleCategory) {
        this.vehicleSelect = vehicleCategory.id;
        this.vehicleRequired = true;
      }

      this.vehicleSelect =
        this.dataWelcomeLto.vehicleFinancingId.find((v) => !v.weekPrice)?.id ||
        '';
      this.vehicleRequired = true;

      if (this.referralCode) {
        const referido = this.dataWelcomeLto.waysFindOut.find(
          (ways) => ways.name == 'Referido'
        );
        if (referido) {
          this.formStepWelcomeLto.controls['whereFindOutId']!.setValue(
            referido.id
          );
        }
      }
    }
  }

  getWayFindOutById(id: string): string {
    return this.dataWelcomeLto.waysFindOut.find((ways) => ways.id == id)?.name!;
  }

  checkPrivacyNoticeEvent() {
    this.checkEvent();

    if (
      this.saveAfterAcceptPrivacy &&
      this.formStepWelcomeLto.valid &&
      !(
        this.requestFormService.getDataForm().requestNumber ||
        this.requestNumber
      )
    ) {
      this.saveStepWelcome(false);
    }
  }

  checkEvent() {
    this.formValidEvent.emit(
      !this.formStepWelcomeLto.invalid &&
      !this.emailCtrl.invalid &&
      this.vehicleRequired
    );
  }

  getStepWelcomeObject(): StepWelcomeLto {
    return {
      ...this.formStepWelcomeLto.value,
      mobilePhoneNumber:
        this.requestFormService.getDataForm().requestNumber ||
          this.requestNumber
          ? ''
          : this.formStepWelcomeLto.get('mobilePhoneNumber')?.value,
      email:
        this.requestFormService.getDataForm().requestNumber ||
          this.requestNumber
          ? ''
          : this.emailCtrl.value,
      vehicleFinancingId: this.vehicleSelect,
      promoterEmail: this.emailPromoter ? this.emailPromoter : null,
      workCityId: this.formStepWelcomeLto.get('workCityId')?.value,
      whereFindOutId: this.formStepWelcomeLto.get('whereFindOutId')?.value,
      referredBy: this.referralCode,
    };
  }

  getStepWelcomeObjectUpdate() {
    return {
      vehicleFinancingId: this.vehicleSelect,
      promoterEmail: this.emailPromoter ? this.emailPromoter : null,
      workCityId: this.formStepWelcomeLto.get('workCityId')?.value,
      whereFindOutId: this.formStepWelcomeLto.get('whereFindOutId')?.value,
      firstName: this.formStepWelcomeLto.get('firstName')?.value,
      lastName: this.formStepWelcomeLto.get('lastName')?.value,
      secondLastName: this.formStepWelcomeLto.get('secondLastName')?.value,
      privacyNoticeAccepted: this.formStepWelcomeLto.get(
        'privacyNoticeAccepted'
      )?.value,
      anotherJobCity: this.formStepWelcomeLto.get('anotherJobCity')?.value,
      anotherWayFindOut:
        this.formStepWelcomeLto.get('anotherWayFindOut')?.value,
      referredBy: this.referralCode,
    };
  }

  saveStepWelcome(changeToNextStep = true) {
    if (
      this.requestFormService.getDataForm().requestNumber ||
      this.requestNumber
    ) {
      const putUpdateRequestWelcomeLto$ = this.putDataService
        .putUpdateRequestWelcomeLto(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          this.getStepWelcomeObjectUpdate()
        )
        .subscribe(() => {
          this.stepWelcomeLtoSavedEvent.emit(true);

          if (this.secondaryCreateResponse) {
            this.emailCtrl.disable();
            this.stepWelcomeLtoSavedEvent.emit(true);
            this.formStepWelcomeLto.controls['mobilePhoneNumber'].disable();
            this.openRequestInformationDialog(
              undefined,
              this.secondaryCreateResponse
            );
            this.secondaryCreateResponse = null;
          }
        });
      this.subscriptions.push(putUpdateRequestWelcomeLto$);
    } else {
      this.saveAfterAcceptPrivacy = false;

      if (!this.formStepWelcomeLto.valid) {
        FormsValidators.markFormGroupTouched(this.formStepWelcomeLto);
      }

      if (!changeToNextStep) {
        this.formValidEvent.emit(false);
      }

      const postSaveDataWelcomeLto$ = this.postDataService
        .postSaveDataWelcomeLto(
          this.getCountry().toUpperCase(),
          this.getStepWelcomeObject()
        )
        .pipe(
          finalize(() => {
            if (!changeToNextStep) {
              this.checkEvent();
            }
          })
        )
        .subscribe({
          next: (resp) => {
            this.requestNumber = resp.requestNumber;
            sessionStorage.setItem('requestNumber', this.requestNumber);
            sessionStorage.setItem('email', this.emailCtrl.value);
            sessionStorage.setItem('applicationId', resp.id);

            if (changeToNextStep) {
              this.emailCtrl.disable();
              this.stepWelcomeLtoSavedEvent.emit(true);
              this.formStepWelcomeLto.controls['mobilePhoneNumber'].disable();
              this.openRequestInformationDialog(undefined, resp);
            } else {
              this.secondaryCreateResponse = resp;
            }
          },
          error: (err) => {
            if (changeToNextStep) {
              this.openRequestInformationDialog(err);
            }
          },
        });
      this.subscriptions.push(postSaveDataWelcomeLto$);
    }
  }

  openRequestInformationDialog(
    error?: HttpErrorResponse,
    event?: StepInitResponse
  ) {
    this.requestFormService.setDataPromoterLTO(event?.promoter!);
    let errorMessage = 'Ha ocurrido un error.';

    const errorValidationError = `ValidationError`.match(
      error?.error.errors[0].code
    );

    const errorCodeEmailInUse = `EMAIL_IN_USE`.match(
      error?.error.errors[0].code
    );

    const errorCodePhoneRepeat = `PPHONE_IN_USE`.match(
      error?.error.errors[0].code
    );

    const errorEmailFormat = `Email must be a valid email address`.match(
      error?.error.errors[0].message
    );

    if (errorCodeEmailInUse) {
      errorMessage = `Ya ha sido registrada una solicitud con el correo electrónico que nos proporcionaste.\n
      Si desea retomar una solicitud, puede hacerlo desde la sección de BUSCAR SOLICITUD con su correo electrónico y número de solicitud.`;
    }

    if (errorCodePhoneRepeat) {
      errorMessage = `Ya ha sido registrada una solicitud con el teléfono celular que nos proporcionaste.
      \nSi desea retomar una solicitud, puede hacerlo desde la sección de BUSCAR SOLICITUD con su correo electrónico y número de solicitud.`;
    }

    if (errorValidationError && errorEmailFormat) {
      errorMessage = `Ingrese un formato de email correcto.`;
    }

    if (
      errorValidationError &&
      error?.error.errors[0].field === 'dateOfBirth'
    ) {
      errorMessage = `Ingrese un formato de fecha correcto.`;
    }
    if (event && event.promoter?.telephone != null) {
      errorMessage = `Su solicitud se ha registrado con el número: <strong>${event.requestNumber}</strong>.
         \nPara localizarla y/o continuar con su registro deberá utilizar este número y su correo registrado.
         \nTu ejecutivo de ventas es <strong>${event.promoter?.name}</strong> y lo puedes encontrar en el siguiente teléfono <strong>${event.promoter?.telephone}</strong>
         , quien te puede dar mayor información.`;
    }
    if (event && event.promoter?.email != null) {
      errorMessage = `Su solicitud se ha registrado con el número: <strong>${event.requestNumber}</strong>.
         \nPara localizarla y/o continuar con su registro deberá utilizar este número y su correo registrado.
         \nTu ejecutivo de ventas es <strong>${event.promoter?.name}</strong> y lo puedes encontrar en el siguiente correo <strong>${event.promoter?.email}</strong>
         , quien te puede dar mayor información.`;
    }
    if (
      event &&
      event.promoter?.telephone != null &&
      event?.promoter?.email != null
    ) {
      errorMessage = `Su solicitud se ha registrado con el número: <strong>${event.requestNumber}</strong>.
         \nPara localizarla y/o continuar con su registro deberá utilizar este número y su correo registrado.
         \nTu ejecutivo de ventas es <strong>${event.promoter?.name}</strong> y lo puedes encontrar en el siguiente teléfono <strong>${event.promoter?.telephone}</strong>
         o correo <strong>${event.promoter?.email}</strong>, quien te puede dar mayor información.`;
    }
    if (
      event &&
      event.promoter?.telephone === null &&
      event?.promoter?.email === null
    ) {
      errorMessage = `Su solicitud se ha registrado con el número: <strong>${event.requestNumber}</strong>.
         \nPara localizarla y/o continuar con su registro deberá utilizar este número y su correo registrado.
         \nTu ejecutivo de ventas es <strong>${event.promoter?.name}</strong>, quien te puede dar mayor información.`;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Información de solicitud',
      question: errorMessage,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  loadUpdateFormStepWelcome() {
    this.buildForm(this.requestFormService.getUpdateForm());
    this.emailCtrl.setValue(this.requestFormService.getUpdateForm().email);
    this.vehicleSelect =
      this.requestFormService.getUpdateForm().welcome.vehicleFinancing?.id;
    this.checkEvent();
  }

  buildForm(value: UpdateDataTokenCode) {
    this.formStepWelcomeLto.patchValue({
      firstName: value.welcome.firstName,
      lastName: value.welcome.lastName,
      secondLastName: value.welcome.secondLastName,
      mobilePhoneNumber: value.welcome.mobilePhoneNumber,
      privacyNoticeAccepted: value.privacyNoticeAccepted,
      workCityId: value.welcome.workCity?.id,
      whereFindOutId: value.welcome.whereFindOut?.id,
      anotherWayFindOut: value.welcome.anotherWayFindOut,
      anotherJobCity: value.welcome.anotherWayFindOut,
      vehicleFinancingId: value.welcome.vehicleFinancing?.id,
    });
  }

  isLetter(evt: KeyboardEvent) {
    if (
      evt.code != 'Space' &&
      evt.code != 'Backspace' &&
      evt.code != 'Delete' &&
      evt.code != 'ArrowLeft' &&
      evt.code != 'ArrowRight' &&
      evt.code != 'Tab' &&
      (evt.keyCode < 65 || (evt.keyCode > 90 && evt.keyCode != 192))
    )
      evt.preventDefault();
  }

  openNoticeOfPrivacyDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = '90vh';
    const dialogSubscription$ = this.dialog
      .open(PrivacyTermsComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
    this.subscriptions.push(dialogSubscription$);
  }

  deleteSpaceInit(evt: KeyboardEvent) {
    evt.target?.addEventListener('keyup', (e: any) => {
      const string = e.target!.value;
      e.target.value = string.trimStart();
    });
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }

  validInputAnotherWayFindOut({
    isUserInput,
    source,
  }: MatOptionSelectionChange) {
    if (!isUserInput) {
      return;
    }

    const otherWhereFindOutValidators =
      source.value === 'f166537b-a8f5-4bd5-b71c-651173b768be'
        ? [Validators.required]
        : [];

    this.formStepWelcomeLto.controls['anotherWayFindOut'].setValidators(
      otherWhereFindOutValidators
    );

    this.formStepWelcomeLto.controls[
      'anotherWayFindOut'
    ].updateValueAndValidity();
  }

  //Valida campo ingrese otra ciudad
  validInputAnotherCity({ isUserInput, source }: MatOptionSelectionChange) {
    if (!isUserInput) {
      return;
    }
    const anotherJobCity =
      source.value === 'ecfe9a52-509c-4f95-b327-e887b057ead3'
        ? [Validators.required]
        : [];
    this.formStepWelcomeLto.controls['anotherJobCity'].setValidators(
      anotherJobCity
    );
    this.formStepWelcomeLto.controls['anotherJobCity'].updateValueAndValidity();
  }

  selectVehicle(event: string) {
    this.vehicleSelect = event;
    this.vehicleRequired = true;
    this.checkEvent();
  }
}
